import RequestService from './request-service';

/**
 * Betslip Request Service
 */
export default class CalculateBonusRequest extends RequestService {
  /**
   * Class constructor method
   */
  constructor(placeModel) {
    super();
    /**
     * Set endpoint
     * @type {typeof this.$config.endpoints.calculateBonus}
     */
    this.endpoint = this.$config.endpoints.calculateBonus;
    this.postParams = placeModel;
    /**
     * Add headers
     */
    const { authorizationHeaders } = this.$config;
    this.headers = authorizationHeaders;
    this.addHeader('Culture', APP_SETTINGS.player.language);
    this.addHeader('ExternalUserID', APP_SETTINGS.player.id);
  }
}
